import React, { useEffect, type JSX } from "react";
import styled, { keyframes } from "styled-components";

interface IProps {
  willRender: boolean;
  fadeInDuration?: number;
  fadeOutDuration?: number;
  children?: JSX.Element;
}

export const FadeAnimatedContainer: React.FC<IProps> = ({
  willRender,
  fadeInDuration,
  fadeOutDuration,
  children,
}) => {
  const [shouldRender, setShouldRender] = React.useState(willRender);

  useEffect(() => {
    if (willRender) {
      setShouldRender(willRender);
    }
  }, [willRender]);

  return shouldRender ? (
    <Wrapper
      onAnimationEnd={() => {
        setShouldRender(willRender);
      }}
      $show={willRender}
      $fadeInDuration={fadeInDuration ?? 500}
      $fadeOutDuration={fadeOutDuration ?? 500}
      data-test-id="fade-animated-container"
    >
      {children}
    </Wrapper>
  ) : null;
};

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 100;
  }
`;

const fadeOutAnimation = keyframes`
  0% {
    opacity: 100;
  }
  100% {
    opacity: 0;
  }
`;

const Wrapper = styled.div<{
  $show?: boolean;
  $fadeInDuration: number;
  $fadeOutDuration: number;
}>`
  animation: ${(props) => (props.$show ? fadeInAnimation : fadeOutAnimation)}
    ${(props) =>
      props.$show ? props.$fadeInDuration : props.$fadeOutDuration}ms
    linear forwards;
`;
